import {
  DesktopOutlined, ReadOutlined,
  UserOutlined,
  VideoCameraOutlined
} from "@ant-design/icons";

import HomeView from "../views/home/Home";
import AccountView from "../views/home/Account";
import {UsersViews} from "../views/users/index";
import NotAuthorizedView from "../views/shared/NotAuthorized";
import NotFoundView from "../views/shared/NotFound";
import AdminView from "../views/admin/AdminView";
import FormVideo from "../views/admin/FormVideo";
import VideoEmbed from "../views/home/VideoEmbed";
import Visitas from "../views/admin/Visitas";
import PdfView from "../views/admin/PdfView";
import Simposio2021 from "../views/home/2021Simposio";
import Simposio2020 from "../views/home/2020Simposio";
import Simposio2022 from "../views/home/2022Simposio";


const sharedRoutes = [
  {
    path: "/no-autorizado",
    component: NotAuthorizedView,
  },
  {
    path: "*",
    component: NotFoundView,
  },
];

const dashboardRoutes = [
  {
    layout: "dashboard",
    path: "/",
    name: "Inicio",
    icon: <DesktopOutlined/>,
    sidebar: "single",
    component: HomeView,
  },
  {
    layout: "dashboard",
    path: "/2022-simposio-internacional",
    name: "XXIII Simposio",
    icon: <VideoCameraOutlined/>,
    sidebar: "single",
    component: Simposio2022,
  },
  {
    layout: "dashboard",
    path: "/2021-simposio-internacional",
    name: "XXII Simposio",
    icon: <VideoCameraOutlined/>,
    sidebar: "single",
    component: Simposio2021,
  },
  {
    layout: "dashboard",
    path: "/2020-simposio-internacional",
    name: "XXI Simposio",
    icon: <VideoCameraOutlined/>,
    sidebar: "single",
    component: Simposio2020,
  },
  {
    layout: "dashboard",
    path: "/video",
    name: "Video",
    sidebar: false,
    component: VideoEmbed,
  },
  {
    layout: "dashboard",
    path: "/usuarios",
    name: "Usuarios",
    icon: <ReadOutlined/>,
    sidebar: 'single',
    component: UsersViews,
  },
  {
    layout: "dashboard",
    path: "/cuenta",
    name: "Mi cuenta",
    icon: <UserOutlined/>,
    sidebar: false,
    component: AccountView,
  },
  {
    layout: "dashboard",
    path: "/admin",
    name: "Videos",
    icon: <VideoCameraOutlined/>,
    sidebar: 'single',
    component: AdminView,
  },
  {
    path: "/admin/agregar",
    name: "Agregar video",
    sidebar: false,
    component: FormVideo,
  },
  {
    path: "/admin/editar",
    name: "Editar video",
    sidebar: false,
    component: FormVideo,
  },
  {
    path: "/admin/visitas",
    name: "Visitas",
    sidebar: false,
    component: Visitas,
  },
  {
    path: "/pdf",
    name: "Reconocimiento",
    ver: 'reconocimiento',
    icon: <VideoCameraOutlined/>,
    sidebar: 'single',
    component: PdfView,
  },

  ...sharedRoutes,
];

const publicRoutes = [...sharedRoutes];

export {dashboardRoutes, publicRoutes};
